module.exports = __webpack_public_path__ + "static/media/dog-6.1836dabb.jpg";